import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MvRouteGuardService } from 'src/app/core/services/msal/guards/mv-route-guard.service';
import { AdminResolverService } from './core/services/resolvers/admin.resolver';
import { AdminErrorComponent } from './features/dashboard/components/admin-error/admin-error.component';
import { LandingPageModule } from './features/landing-page/landing-page.module';
import { LoginComponent } from './features/login/login.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'auth', component: MsalRedirectComponent },
  {
    path: 'home',
    loadChildren: () => LandingPageModule,
    canActivate: [MvRouteGuardService],
    resolve: {usersByToken: AdminResolverService},
    data: {headerApp:'headerApp'}
  },
  {
		path: 'admin-error', component: AdminErrorComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }




